// 存物完成
<template>
  <div class="officeLockerOpenBox">
    <!-- 流程 -->
    <step></step>
    <div class="oneBox" v-if="($store.state.officeLocker_openInfo.isOne || box_list.length == 0) && getOpenResult">
      <span class="status" :class="[box.isOpen ? 'success' : 'fail']"></span>
      <p class="info" v-if="box.isOpen">已经为您打开编号为：
        <span class="num">{{box.box_size}}-{{box.box_number}}号箱格</span>
      </p>
      <p class="des">{{box_list.length == 0 ? '此用户暂无权限使用' : box.isOpen ? '请存放物品并随手关门' : '开门失败，请联系工作人员'}}</p>
      <!-- 再存一个 -->
      <p
        class="save-again"
        v-show="$store.state.type === 'express' && box.showStatus"
        @click="saveAgain">
        再存一个
      </p>
      <countDown></countDown>
    </div>
    <div class="moreBox" v-if="!$store.state.officeLocker_openInfo.isOne && box_list.length >1">
      <div class="box-list">
        <div
          class="list"
          v-for="(box, index) in box_list"
          :key="box.box_number">
          <p class="num">编号：{{box.box_size}}-{{box.box_number}}</p>
          <p class="open" :class="[box.isOpen ? 'opened' : '']"
            v-html="box.isOpen ? '已打开<span>请取出物品</span>' : '打开'"
            @click="openBox(index)"></p>
        </div>
      </div>
      <countDown :time=60></countDown>
    </div>
    <span class="logOutBtn" @click="logOut">退出登录</span>
  </div>
</template>

<script>
  import step from './module/step.vue'
  import countDown from './module/countDown'
  import { showLoading, hideLoading, messageError, messageSuccess, messageClose } from '../../../../static/js/utils/utility.js'
  import { deepCopy } from '../../../../static/js/utils/utility'
  import { officeLockerApi } from '../../../../static/officeLocker/js/api';
  var vm

export default {
  name: 'officeLockerOpenBox',
  components: {
    step,
    countDown
  },
  data () {
    return {
      box: {},
      box_list: [],
      getOpenResult: false
    }
  },
  created () {
    vm = this
    console.log('tag', vm.$store.state.officeLocker_openInfo)
  },
  mounted () {
    vm.dealWithBox()
  },
  methods: {
    // 处理箱格信息
    dealWithBox () {
      let resData = vm.$store.state.officeLocker_openInfo
      let box_list = [...resData.box_list]
      for (let i in box_list) {
        box_list[i].isOpen = false
      }
      vm.box_list = [...box_list]
      console.log('tag', vm.box_list)
      // 只有一个箱格
      if (resData.isOne) {
        vm.openBox(0)
      } else if(box_list.length == 0) {
        vm.getOpenResult = true
      }
    },
    // 开箱
    async openBox(index){
      let box_list = [...vm.box_list]
      if (box_list[index].isOpen) { return }

      let data = vm.$store.state.officeLocker_loginInfo
      data.type = 1
      data.box_number = box_list[index].box_number
      
      showLoading('正在开门')
      let res = await officeLockerApi.openBox(data)
      hideLoading()
      if (res.meta.code == 200) {
        box_list[index].isOpen = true
        vm.box_list = [...box_list]
        // 一个箱格显示状态
        vm.getOpenResult = true
        vm.box = deepCopy(vm.box_list[0])
      }else {
        messageError(res.meta.message)
      }
    },
    // 再存一个
    saveAgain: function () {
      
    },
    // 退出登录
    logOut () {
      this.$router.push({
        path: '/officeLocker'
      })
    }
  }
}
</script>

<style lang="less">
.officeLockerOpenBox{
  width: 100%;
  text-align: center;
  padding: 0.9rem 0 0;
  .oneBox {
    .status{
      display: block;
      width: 2rem;
      height: 2rem;
      margin: 0.8rem auto 0.45rem;
    }
    .status.success{
      background: url(../../../../static/turnoverCabinet/images/icon/success.png) center no-repeat;
      background-size: 100%;
    }
    .status.fail{
      background: url(../../../../static/turnoverCabinet/images/icon/fail.png) center no-repeat;
      background-size: 100%;
    }
    .info,
    .des{ 
      font-size: 0.45rem;
      line-height: 0.85rem;
    }
    .info{
      margin-bottom: 0.45rem;
    }
    .hint{
      font-size: 15px;
      color: #ff0000;
      position: absolute;
      bottom: 80px;
      left: 0;
      right: 0;
      margin: auto;
    }
    .save-again{
      display: block;
      width: 4.56rem;
      margin: 0.5rem auto 0;
      height: 1.82rem;
      line-height: 1.82rem;
      text-align: center;
      border-radius: 0.1rem;
      font-size: 0.7rem;
      font-weight: bold;
      padding: 0;
      background: -webkit-linear-gradient(to top ,#076abf, #4cacff); /* Safari 5.1 - 6.0 */
      background: -o-linear-gradient(to top,#076abf, #4cacff); /* Opera 11.1 - 12.0 */
      background: -moz-linear-gradient(to top,#076abf, #4cacff); /* Firefox 3.6 - 15 */
      background: linear-gradient(to top,#076abf, #4cacff);
      box-shadow: #2c4b64 0px 0px 0.2rem;
    }
  }
  .moreBox {
    width: 9.62rem;
    margin: 0 auto;
    overflow: hidden;
  }
  .box-list{
    // width: 9.62rem;
    width: calc(9.62rem + 20px);
    height: 5.8rem;
    margin-top: 1rem;
    overflow-x: hidden;
    overflow-y: scroll;
    display: flex;
    flex-wrap: wrap;
    .list{
      width: 4.56rem;
      height: 1.6rem;
      margin-bottom: 0.5rem;
      border-radius: 0.1rem;
      display: flex;
      .num,
      .open{
        height: 1.6rem;
        line-height: 1.6rem;
      }
      .num{
        width: 70%;
        font-size: 0.34rem;
        padding-left: 0.3rem;
        border-top-left-radius: 0.1rem;
        border-bottom-left-radius: 0.1rem;
        color: #333333;
        background-color: #ffffff;
      }
      .open{
        width:30%;
        color: #ffffff;
        font-size: 0.34rem;
        text-align: center;
        border-top-right-radius: 0.1rem;
        border-bottom-right-radius: 0.1rem;
        background: -webkit-linear-gradient(to top ,#076abf, #4cacff); /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(to top,#076abf, #4cacff); /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(to top,#076abf, #4cacff); /* Firefox 3.6 - 15 */
        background: linear-gradient(to top,#076abf, #4cacff);
      }
      .open.opened{
        line-height: 0.34rem;
        background: #3e97df;
        padding-top: 0.45rem;
      }
      .open.opened span{
        display: block;
        font-size: 0.24rem;
        line-height: 0.24rem;
        margin-top: 0.15rem;
      }
    }
    .list:nth-child(odd){
      margin-right: 0.5rem;
    }
  }
  .logOutBtn{
    display: block;
    width: 2.04rem;
    height: 0.88rem;
    line-height: 0.88rem;
    font-size: 0.34rem;
    border-radius: 0.1rem;
    text-align: center;
    color: #ffffff;
    background: linear-gradient(to top,#0669be, #4babfe);
    position: fixed;
    right: 0.5rem;
    bottom: 1rem;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/officeLocker/page/openBox.vue